<h2 class="m-b-5" mat-dialog-title>Nuevo Documento</h2>

<div mat-dialog-content id="baja-edit-card">
  <form class="add-document-form" [formGroup]="NewDocumentFormGroup" role="form" autocomplete="off">

    <mat-form-field floatLabel="always" class="m-b-5">
      <mat-select placeholder="Tipo de Documento" formControlName="DocumentType">
        <mat-option *ngFor="let docType of documentTypes" [value]="docType.value">
          {{docType.viewValue}} 
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-error *ngIf="(NewDocumentFormGroup.get('DocumentType').dirty || NewDocumentFormGroup.get('DocumentType').touched ) && NewDocumentFormGroup.get('DocumentType').invalid">
      <span *ngIf="NewDocumentFormGroup.get('DocumentType').errors.required" class="validation-span ">Obligatorio</span>
    </mat-error>

    <mat-form-field floatLabel="always">
      <textarea matInput placeholder="Descripción" formControlName="Description"></textarea>
    </mat-form-field>

    <div class="uploadfilecontainer m-t-10 m-b-10" (click)="fileInput.click()" appDragAndDrop (OnFileDropped)="uploadFile($event)">
      <input hidden type="file" 
        formControlName="Document" 
        #fileInput 
        (change)="uploadFile($event.target.files)"
        accept="{{FileFormatEnum.TrabajadorControllerDocumento}}">
        <!--accept="image/tiff,image/bmp,image/png,image/jpeg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword">-->
        <!-- 10/10/2023 aqui arriba va el otro archivo parece que son el tipo principal de adjuntar archivo de trabajador en su ficha, probar a sustituirlo por el enum, PROBAR ESTO MAÑANA -->
      <mat-error
        *ngIf="(NewDocumentFormGroup.get('Document').dirty || NewDocumentFormGroup.get('Document').touched ) && NewDocumentFormGroup.get('Document').invalid">
        <span *ngIf="NewDocumentFormGroup.get('Document').errors.required" class="validation-span">Obligatorio</span>
      </mat-error>
      <mat-icon class="f-s-19 upload_icon">cloud_upload</mat-icon>
    </div>

    <mat-form-field class="w-120" floatLabel="always">
      <mat-label>Fecha</mat-label>
      <input formControlName="Date" matInput [matDatepicker]="date"
      placeholder="Fecha" (click)="date.open()">
    <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
    <mat-datepicker #date></mat-datepicker>
    </mat-form-field>

    <div class="files-list" *ngIf="file">
      <p> {{ file }} </p>
      <button class="delete-file" (click)="deleteAttachment()">
        <mat-icon class="f-s-19">delete_forever</mat-icon>
      </button>
    </div>
    
  </form>
</div>
<mat-progress-bar class="m-t-5" mode="indeterminate" *ngIf="IsSaving"></mat-progress-bar>
<div class="text-a-r p-t-5">
  <button class="m-r-15" mat-raised-button color="accent" (click)="AddDocument()">Guardar</button>
  <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>